/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsPi: {
  name: 'pi';
  data: string;
} = {
  name: 'pi',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><g clip-path="url(#a)"><path fill-rule="evenodd" clip-rule="evenodd" d="M1.5 3A1.5 1.5 0 0 1 3 1.5h12a.5.5 0 0 0 0-1H3a2.5 2.5 0 0 0 0 5 .5.5 0 0 0 0-1A1.5 1.5 0 0 1 1.5 3Zm5 1a.5.5 0 0 0-1 0v11a.5.5 0 0 0 1 0V4Zm5 0a.5.5 0 0 0-1 0v11a.5.5 0 0 0 1 0V4Z" fill="currentColor"/></g><defs><clipPath id="a"><path fill="currentColor" d="M0 0h16v16H0z"/></clipPath></defs></svg>`,
};
